<template lang="pug">
  div
    el-row.labelStyle
      el-col(:span="12")
        app-display(label="Estado:" :content="dadosJson.localizacao.municipio.codigoEstado || '-'")
      el-col(v-if="dadosJson.localizacao.geometrias && dadosJson.localizacao.geometrias.length" :span="24")
        div.pad
          app-resumo-mapa(
            :idMapa="'id-mapa-localizacao-uc'"
            :height="30"
            :localizacoes="dadosJson.localizacao.geometrias",
            :isVisualizarCadastro="true"
          )
</template>

<script>
import AppDivider from '../AppDivider'
import AppLabel from '../AppLabel'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import AppResumoMapa from '@/components/resumo/AppResumoMapa'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: true
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple,
    AppResumoMapa,
    AppLabel
  },
  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

.pad {
  padding: 15px 5px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/LocalizacaoUc.vue